export default "__VITE_ASSET__Dgynmagl__"